export default __webpack_public_path__ + "static/media/P204.1.45dadf47.mp3";